import { render, staticRenderFns } from "./FlashMessage.vue?vue&type=template&id=124921dc&scoped=true&"
import script from "./FlashMessage.vue?vue&type=script&lang=js&"
export * from "./FlashMessage.vue?vue&type=script&lang=js&"
import style0 from "./FlashMessage.vue?vue&type=style&index=0&id=124921dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124921dc",
  null
  
)

export default component.exports